module.exports = __webpack_public_path__ + "img/blank.b00167f4.png";